import { render, staticRenderFns } from "./DeleteCorsDialog.vue?vue&type=template&id=233e1c89"
import script from "./DeleteCorsDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCorsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports